<!-- Message-thread dialog — profile redesign. The vb-dialog shell owns the
     scrim, focus trap, and ✕ close; the body is the thread ledger plus the
     compose field, all on design tokens. -->
<vb-dialog
    [open]="open"
    eyebrow="Message"
    [title]="topicLabel || topic"
    [showClose]="true"
    (closed)="onClose()">
    <!-- Link to the lot / invoice the thread is about (resolved on open;
         absent on threads created before context ids were stored). -->
    <a
        class="msg-thread__context-link"
        *ngIf="contextLink"
        [routerLink]="contextLink.route"
        (click)="onClose()">
        {{ contextLink.label }}
        <vb-icon name="chevRight" [size]="14" />
    </a>

    <div class="vb-spinner-box vb-spinner-box--inline" *ngIf="isLoading">
        <vb-spinner size="xl" label="Loading messages"></vb-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
        <!-- Thread ledger — oldest first. Seller/admin replies carry the red
             accent + sender, mirroring the table legend's unread red. -->
        <div class="msg-thread__list">
            <div
                class="msg-thread__item"
                *ngFor="let comment of comments"
                [class.msg-thread__item--admin]="
                    comment.createdBy !== originalId
                ">
                <div class="msg-thread__meta">
                    <span class="msg-thread__from">
                        {{
                            comment.createdBy === originalId
                                ? comment.username
                                : "Admin"
                        }}
                    </span>
                    <span class="msg-thread__date">
                        {{ comment.createdOn | vbDateTime }}
                    </span>
                </div>
                <p class="msg-thread__text">{{ comment.comments }}</p>
            </div>
        </div>

        <!-- Compose -->
        <div class="msg-thread__compose">
            <div class="msg-thread__compose-head">
                <label class="msg-thread__label" for="thread-message">
                    Send another message
                </label>
                <span class="msg-thread__count">
                    {{ messageLength }} / 1000
                </span>
            </div>
            <form [formGroup]="messengerForm">
                <textarea
                    id="thread-message"
                    class="msg-thread__textarea"
                    [class.msg-thread__textarea--error]="isMessageFormError"
                    formControlName="message"
                    rows="4"
                    maxlength="1000"
                    placeholder="Start typing here…"
                    [attr.disabled]="isMessageSend ? true : null"
                    (input)="onMessageInput()"></textarea>
            </form>
            <span class="msg-thread__error" *ngIf="isMessageFormError">
                {{ translate.instant("Chatbox.messageError") }}
            </span>
        </div>
    </ng-container>

    <!-- Footer row inside the shell's stacking footer slot: delete on the
         left, Cancel/Send on the right (ghost is the system's red text
         button — same vocabulary as the row kebab's danger item). -->
    <div class="msg-thread__footer" dialogFooter>
        <vb-button variant="ghost" (clicked)="onDeleteConversation()">
            Delete conversation
        </vb-button>
        <div class="msg-thread__actions">
            <vb-button variant="secondary" (clicked)="onClose()">
                Cancel
            </vb-button>
            <vb-button
                variant="primary"
                [loading]="isMessageSend"
                (clicked)="onSubmit()">
                Send
            </vb-button>
        </div>
    </div>
</vb-dialog>
